import { COLORS } from "./colors";

export const COLORS_AB = {
  ...COLORS,
  PRIMARY_GREEN: {
    50: "#EEF5EF",
    100: "#DDEBE0",
    200: "#BFD8C2",
    300: "#9EC3A2",
    400: "#7EAE85",
    500: "#5F996D",
    600: "#4A815A",
    700: "#3B684A",
    800: "#2A4E38",
    900: "#0C362D",
  },
  SECONDARY_GREEN: {
    50: "#F1F5F2",
    100: "#E1ECE4",
    200: "#C4D9C9",
    300: "#A7C6AE",
    400: "#6F9E7D",
    500: "#0C362D",
    600: "#0A2E26",
    700: "#08261F",
    800: "#061E18",
    900: "#041611",
  },
  PRIMARY_GREEN_DARK: {
    50: "#113E35",
    100: "#0F3931",
    200: "#0E342D",
    300: "#0D3029",
    400: "#0C2B25",
    500: "#0C362D",
    600: "#0A2E26",
    700: "#08261F",
    800: "#061E18",
    900: "#000000",
  },
  SECONDARY_GREEN_DARK: {
    50: "#8c9694",
    100: "#80938f",
    200: "#678d85",
    300: "#4e877c",
    400: "#358172",
    500: "#1c7b69",
    600: "#156c5c",
    700: "#155d4f",
    800: "#124e42",
    900: "#0e3f35",
  },
};
